import React, { useEffect, useState } from "react";
import { CommonListType, useCommonListWrap } from "../../../hooks/useCommonList/useCommonListWrap";
import Location from "../../../../models/Location";
import {
    getDetailDestinations,
    getListDestinations,
    getRecommendLocation,
    getTopDestinations,
    offlineGetDetailDestination,
} from "../../../../services/LocationService";
import { withSsrRawDataMulti } from "../../../controls/common/StaticContextWrap";
import useStaticContext from "../../../hooks/useStaticContext";
import { EmailTemplateData, getButton, getEmailContent, getEmailKeywork } from "../../../../services/EmailSerivce";

export default function useGetButtonEmailContent() {
    const [button, setButton] = useState<EmailTemplateData[]>();
    const loadButton = async () => {
        try {
            let prods = await getButton();
            setButton(prods.data);
        } catch (error) {
            console.error(error);
        }
    };
    const reload = () => {
        loadButton();
    };
    useEffect(() => {
            reload();
    }, []);
    return {
        button,
        reload,
    };
}
